import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "종속성 관리",
  "description": "모노레포의 Workspace에서 종속성을 관리하는 방법을 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "외부 종속성은 npm 레지스트리에서 제공되며, 생태계의 귀중한 코드를 활용하여 애플리케이션과 라이브러리를 더 빠르게 빌드할 수 있습니다."
  }, {
    "heading": "",
    "content": "내부 종속성을 사용하면 저장소 내에서 기능을 공유할 수 있어 공유 코드의 검색 가능성과 사용성이 크게 향상됩니다. 내부 패키지를 빌드하는 방법에 대해서는 다음 가이드에서 논의하겠습니다."
  }, {
    "heading": "사용되는-곳에-종속성-설치",
    "content": "저장소에 종속성을 설치할 때 해당 종속성을 사용하는 패키지에 직접 설치해야 합니다. 패키지의 package.json에는 패키지에 필요한 모든 종속성이 있습니다. 이는 외부 및 내부 종속성 모두에 적용됩니다."
  }, {
    "heading": "사용되는-곳에-종속성-설치",
    "content": "패키지 관리자가 패키지와 다른 node_modules 위치를\n사용하도록 선택할 수 있습니다."
  }, {
    "heading": "사용되는-곳에-종속성-설치",
    "content": "여러 패키지에 빠르게 종속성을 설치하려면 패키지 관리자를 사용할 수 있습니다:"
  }, {
    "heading": "사용되는-곳에-종속성-설치",
    "content": "Yarn 1:"
  }, {
    "heading": "사용되는-곳에-종속성-설치",
    "content": "Yarn 1 문서"
  }, {
    "heading": "사용되는-곳에-종속성-설치",
    "content": "Yarn 2+:"
  }, {
    "heading": "사용되는-곳에-종속성-설치",
    "content": "Yarn 2+ 문서"
  }, {
    "heading": "사용되는-곳에-종속성-설치",
    "content": "이 관행에는 여러 가지 이점이 있습니다:"
  }, {
    "heading": "사용되는-곳에-종속성-설치",
    "content": "명확성 향상: 패키지의 종속성이 package.json에 나열되어 있으면 패키지가 의존하는 것을 이해하기가 더 쉽습니다. 저장소에서 작업하는 개발자는 패키지 내에서 사용되는 종속성을 한눈에 볼 수 있습니다."
  }, {
    "heading": "사용되는-곳에-종속성-설치",
    "content": "유연성 향상: 대규모 모노레포에서는 각 패키지가 외부 종속성의 동일한 버전을 사용할 것으로 기대하는 것이 비현실적일 수 있습니다. 동일한 코드베이스에서 작업하는 많은 팀이 있을 때 대규모 운영의 현실로 인해 우선순위, 일정 및 요구 사항이 달라집니다. 사용되는 패키지에 종속성을 설치하면 ui 팀이 TypeScript의 최신 버전으로 업데이트할 수 있고 web 팀은 새로운 기능을 제공하는 데 우선순위를 두고 나중에 TypeScript를 업데이트할 수 있습니다. 또한 여전히 종속성 버전을 동기화하려면 그렇게 할 수도 있습니다."
  }, {
    "heading": "사용되는-곳에-종속성-설치",
    "content": "더 나은 캐싱 능력: 저장소 루트에 너무 많은 종속성을 설치하면 종속성을 추가, 업데이트 또는 삭제할 때마다 Workspace 루트를 변경하여 불필요한 캐시 미스가 발생합니다."
  }, {
    "heading": "사용되는-곳에-종속성-설치",
    "content": "사용되지 않는 종속성 정리: Docker 사용자의 경우 Turborepo의 정리 기능을 사용하여 Docker 이미지에서 사용되지 않는 종속성을 제거하여 더 가벼운 이미지를 만들 수 있습니다. 종속성이 의도된 패키지에 설치되면 Turborepo는 lockfile을 읽고 필요한 패키지에서 사용되지 않는 종속성을 제거할 수 있습니다."
  }, {
    "heading": "루트에-종속성-적게",
    "content": "위의 첫 번째 원칙에 따라 사용되는 곳에 종속성 설치하면 자연스럽게 Workspace 루트에 종속성이 거의 없게 됩니다."
  }, {
    "heading": "루트에-종속성-적게",
    "content": "Workspace 루트에 속하는 유일한 종속성은 저장소 관리를 위한 도구이며, 애플리케이션과 라이브러리를 빌드하기 위한 종속성은 해당 패키지에 설치됩니다. 루트에 설치하는 것이 합리적인 종속성의 몇 가지 예는 turbo, husky 또는 lint-staged입니다."
  }, {
    "heading": "turborepo는-종속성을-관리하지-않음",
    "content": "Turborepo는 종속성 관리에서 역할을 하지 않으며, 해당 작업을 선택한 패키지 관리자에 맡깁니다."
  }, {
    "heading": "turborepo는-종속성을-관리하지-않음",
    "content": "올바른 외부 종속성 버전 다운로드, 심볼릭 링크 생성 및 모듈 해결과 같은 작업을 처리하는 것은 패키지 관리자의 몫입니다. 이 페이지의 권장 사항은 Workspace에서 종속성을 관리하기 위한 모범 사례이며 Turborepo에서 강제하지 않습니다."
  }, {
    "heading": "패키지-관리자-간-모듈-해결-차이",
    "content": "패키지 관리자에는 서로 다른 모듈 해결 알고리즘이 있어 예측하기 어려운 동작 차이가 발생합니다."
  }, {
    "heading": "패키지-관리자-간-모듈-해결-차이",
    "content": "Turborepo 문서에서는 패키지 관리자의 예상 동작에 따라 많은 권장 사항을 제공합니다. 종속성 처리 방법에 대한 범위는 최선의 노력이며 패키지 관리자 또는 저장소의 요구 사항에 맞게 문서화된 동작을 조정해야 할 수 있습니다."
  }, {
    "heading": "패키지-관리자-간-모듈-해결-차이",
    "content": "그러나 모든 패키지 관리자 또는 특정 패키지 관리자에 대해 보편적으로 잘못된 것으로 보이는 문서 문제를 발견하면 GitHub Issue를 통해 알려주시면 개선할 수 있습니다."
  }, {
    "heading": "node_modules-위치",
    "content": "패키지 관리자 선택, 버전, 설정 및 Workspace에서 종속성이 설치된 위치에 따라 Workspace 내의 다양한 위치에서 node_modules와 그 안의 종속성을 볼 수 있습니다. 종속성은 루트 node_modules, 패키지의 node_modules 또는 둘 다에서 찾을 수 있습니다."
  }, {
    "heading": "node_modules-위치",
    "content": "스크립트와 작업이 필요한 종속성을 찾을 수 있는 한 패키지 관리자가 올바르게 작동하고 있는 것입니다."
  }, {
    "heading": "node_modules-위치",
    "content": "Workspace 내 node_modules의 특정 위치는 패키지 관리자의 공개 API의 일부가 아닙니다. 즉, node_modules를 직접 참조하는 것(예: node ./node_modules/a-package/dist/index.js)은 Workspace 주변의 다른 종속성 변경으로 인해 디스크의 종속성 위치가 변경될 수 있으므로 취약할 수 있습니다."
  }, {
    "heading": "node_modules-위치",
    "content": "대신 가능한 한 Node.js 생태계의 규칙을 사용하여 종속성 모듈에 액세스하세요."
  }, {
    "heading": "동일한-버전의-종속성-유지",
    "content": "일부 모노레포 유지 관리자는 규칙에 따라 모든 패키지에서 종속성을 동일한 버전으로 유지하는 것을 선호합니다. 이를 달성하는 방법에는 여러 가지가 있습니다:"
  }, {
    "heading": "전용-도구-사용",
    "content": "이 특정 목적을 위해 syncpack, manypkg 및 sherif와 같은 도구를 사용할 수 있습니다."
  }, {
    "heading": "패키지-관리자-사용",
    "content": "패키지 관리자를 사용하여 하나의 명령으로 종속성 버전을 업데이트할 수 있습니다."
  }, {
    "heading": "패키지-관리자-사용",
    "content": "Yarn 1:"
  }, {
    "heading": "패키지-관리자-사용",
    "content": "Yarn 2+:"
  }, {
    "heading": "패키지-관리자-사용",
    "content": "동등한 명령 없음"
  }, {
    "heading": "pnpm-카탈로그",
    "content": "pnpm v9.5+에서는 카탈로그를 사용하여 종속성 버전 범위를 재사용 가능한 상수로 정의할 수 있습니다. Workspace 전체에서 동일한 값을 참조하므로 종속성을 동일한 버전으로 유지합니다."
  }, {
    "heading": "pnpm-카탈로그",
    "content": "자세한 내용은 pnpm 카탈로그 문서를 방문하세요."
  }, {
    "heading": "ide-사용",
    "content": "IDE의 리팩토링 도구를 사용하여 저장소의 모든 package.json 파일에서 종속성 버전을 한 번에 찾고 바꿀 수 있습니다. package.json 파일에서 next 패키지의 모든 인스턴스를 찾고 원하는 버전으로 바꾸려면 \"next\": \".*\"와 같은 정규식을 사용해 보세요. 완료되면 패키지 관리자의 install 명령을 실행하여 lockfile을 업데이트해야 합니다."
  }, {
    "heading": "다음-단계",
    "content": "이제 Workspace에서 효과적으로 종속성을 관리하는 방법을 알았으므로 모노레포에서 종속성으로 사용할 Internal Package를 생성해 보겠습니다."
  }],
  "headings": [{
    "id": "종속성-설치-모범-사례",
    "content": "종속성 설치 모범 사례"
  }, {
    "id": "사용되는-곳에-종속성-설치",
    "content": "사용되는 곳에 종속성 설치"
  }, {
    "id": "루트에-종속성-적게",
    "content": "루트에 종속성 적게"
  }, {
    "id": "종속성-관리",
    "content": "종속성 관리"
  }, {
    "id": "turborepo는-종속성을-관리하지-않음",
    "content": "Turborepo는 종속성을 관리하지 않음"
  }, {
    "id": "패키지-관리자-간-모듈-해결-차이",
    "content": "패키지 관리자 간 모듈 해결 차이"
  }, {
    "id": "node_modules-위치",
    "content": "node_modules 위치"
  }, {
    "id": "동일한-버전의-종속성-유지",
    "content": "동일한 버전의 종속성 유지"
  }, {
    "id": "전용-도구-사용",
    "content": "전용 도구 사용"
  }, {
    "id": "패키지-관리자-사용",
    "content": "패키지 관리자 사용"
  }, {
    "id": "pnpm-카탈로그",
    "content": "pnpm 카탈로그"
  }, {
    "id": "ide-사용",
    "content": "IDE 사용"
  }, {
    "id": "다음-단계",
    "content": "다음 단계"
  }]
};
import {PackageManagerTabs, Tab} from '#components/tabs';
import {Callout} from '#components/callout';
import {LinkToDocumentation} from '#components/link-to-documentation';
export const toc = [{
  depth: 2,
  url: "#종속성-설치-모범-사례",
  title: _jsx(_Fragment, {
    children: "종속성 설치 모범 사례"
  })
}, {
  depth: 3,
  url: "#사용되는-곳에-종속성-설치",
  title: _jsx(_Fragment, {
    children: "사용되는 곳에 종속성 설치"
  })
}, {
  depth: 3,
  url: "#루트에-종속성-적게",
  title: _jsx(_Fragment, {
    children: "루트에 종속성 적게"
  })
}, {
  depth: 2,
  url: "#종속성-관리",
  title: _jsx(_Fragment, {
    children: "종속성 관리"
  })
}, {
  depth: 3,
  url: "#turborepo는-종속성을-관리하지-않음",
  title: _jsx(_Fragment, {
    children: "Turborepo는 종속성을 관리하지 않음"
  })
}, {
  depth: 3,
  url: "#패키지-관리자-간-모듈-해결-차이",
  title: _jsx(_Fragment, {
    children: "패키지 관리자 간 모듈 해결 차이"
  })
}, {
  depth: 3,
  url: "#node_modules-위치",
  title: _jsx(_Fragment, {
    children: "node_modules 위치"
  })
}, {
  depth: 3,
  url: "#동일한-버전의-종속성-유지",
  title: _jsx(_Fragment, {
    children: "동일한 버전의 종속성 유지"
  })
}, {
  depth: 4,
  url: "#전용-도구-사용",
  title: _jsx(_Fragment, {
    children: "전용 도구 사용"
  })
}, {
  depth: 4,
  url: "#패키지-관리자-사용",
  title: _jsx(_Fragment, {
    children: "패키지 관리자 사용"
  })
}, {
  depth: 4,
  url: "#pnpm-카탈로그",
  title: _jsx(_Fragment, {
    children: "pnpm 카탈로그"
  })
}, {
  depth: 4,
  url: "#ide-사용",
  title: _jsx(_Fragment, {
    children: "IDE 사용"
  })
}, {
  depth: 2,
  url: "#다음-단계",
  title: _jsx(_Fragment, {
    children: "다음 단계"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "외부 종속성"
        }), "은 ", _jsx(_components.a, {
          href: "https://www.npmjs.com/",
          children: "npm 레지스트리"
        }), "에서 제공되며, 생태계의 귀중한 코드를 활용하여 애플리케이션과 라이브러리를 더 빠르게 빌드할 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "내부 종속성"
        }), "을 사용하면 저장소 내에서 기능을 공유할 수 있어 공유 코드의 검색 가능성과 사용성이 크게 향상됩니다. 내부 패키지를 빌드하는 방법에 대해서는 ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/creating-an-internal-package",
          children: "다음 가이드"
        }), "에서 논의하겠습니다."]
      }), "\n"]
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"next\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // 외부 종속성"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // 내부 종속성"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"next\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // 외부 종속성"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // 내부 종속성"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"next\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // 외부 종속성"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // 내부 종속성"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun (Beta)",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"next\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"latest\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // 외부 종속성"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: " // 내부 종속성"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "종속성-설치-모범-사례",
      children: "종속성 설치 모범 사례"
    }), "\n", _jsx(_components.h3, {
      id: "사용되는-곳에-종속성-설치",
      children: "사용되는 곳에 종속성 설치"
    }), "\n", _jsxs(_components.p, {
      children: ["저장소에 종속성을 설치할 때 해당 종속성을 사용하는 패키지에 직접 설치해야 합니다. 패키지의 ", _jsx(_components.code, {
        children: "package.json"
      }), "에는 패키지에 필요한 모든 종속성이 있습니다. 이는 외부 및 내부 종속성 모두에 적용됩니다."]
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: ["패키지 관리자가 ", _jsx(_components.a, {
          href: "#node_modules-locations",
          children: "패키지와 다른 node_modules 위치를\n사용"
        }), "하도록 선택할 수 있습니다."]
      })
    }), "\n", _jsx(_components.p, {
      children: "여러 패키지에 빠르게 종속성을 설치하려면 패키지 관리자를 사용할 수 있습니다:"
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsxs(Tab, {
        value: "pnpm",
        children: [_jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " jest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --save-dev"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --recursive"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --filter=web"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --filter=@repo/ui"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --filter=docs"
                })]
              })
            })
          })
        }), _jsx(LinkToDocumentation, {
          href: "https://pnpm.io/cli/recursive",
          children: "pnpm 문서"
        })]
      }), _jsxs(Tab, {
        value: "yarn",
        children: [_jsx(_components.p, {
          children: "Yarn 1:"
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " workspace"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " web"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " jest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --dev"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " workspace"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " @repo/ui"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " jest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --dev"
                })]
              })]
            })
          })
        }), _jsx(LinkToDocumentation, {
          href: "https://classic.yarnpkg.com/en/docs/cli/add",
          children: _jsx(_components.p, {
            children: "Yarn 1 문서"
          })
        }), _jsx(_components.p, {
          children: "Yarn 2+:"
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " workspaces"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " foreach"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -R"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " '{web,@repo/ui}'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " add"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " jest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --dev"
                })]
              })
            })
          })
        }), _jsx(LinkToDocumentation, {
          href: "https://yarnpkg.com/cli/workspaces/foreach#usage",
          children: _jsx(_components.p, {
            children: "Yarn 2+ 문서"
          })
        })]
      }), _jsxs(Tab, {
        value: "npm",
        children: [_jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " jest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --workspace=web"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --workspace=@repo/ui"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --save-dev"
                })]
              })
            })
          })
        }), _jsx(LinkToDocumentation, {
          href: "https://docs.npmjs.com/cli/v7/using-npm/config#workspace",
          children: "npm 문서"
        })]
      }), _jsxs(Tab, {
        value: "bun (Beta)",
        children: [_jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bun"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " jest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --filter=web"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --filter=@repo/ui"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --dev"
                })]
              })
            })
          })
        }), _jsx(LinkToDocumentation, {
          href: "https://bun.sh/docs/install/workspaces",
          children: "bun 문서"
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "이 관행에는 여러 가지 이점이 있습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "명확성 향상"
        }), ": 패키지의 종속성이 ", _jsx(_components.code, {
          children: "package.json"
        }), "에 나열되어 있으면 패키지가 의존하는 것을 이해하기가 더 쉽습니다. 저장소에서 작업하는 개발자는 패키지 내에서 사용되는 종속성을 한눈에 볼 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "유연성 향상"
        }), ": 대규모 모노레포에서는 각 패키지가 외부 종속성의 동일한 버전을 사용할 것으로 기대하는 것이 비현실적일 수 있습니다. 동일한 코드베이스에서 작업하는 많은 팀이 있을 때 ", _jsx(_components.a, {
          href: "https://vercel.com/blog/how-to-scale-a-large-codebase",
          children: "대규모 운영"
        }), "의 현실로 인해 우선순위, 일정 및 요구 사항이 달라집니다. 사용되는 패키지에 종속성을 설치하면 ", _jsx(_components.code, {
          children: "ui"
        }), " 팀이 TypeScript의 최신 버전으로 업데이트할 수 있고 ", _jsx(_components.code, {
          children: "web"
        }), " 팀은 새로운 기능을 제공하는 데 우선순위를 두고 나중에 TypeScript를 업데이트할 수 있습니다. 또한 여전히 종속성 버전을 동기화하려면 ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/managing-dependencies#keeping-dependencies-on-the-same-version",
          children: "그렇게 할 수도 있습니다"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "더 나은 캐싱 능력"
        }), ": 저장소 루트에 너무 많은 종속성을 설치하면 종속성을 추가, 업데이트 또는 삭제할 때마다 Workspace 루트를 변경하여 불필요한 캐시 미스가 발생합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "사용되지 않는 종속성 정리"
        }), ": Docker 사용자의 경우 ", _jsx(_components.a, {
          href: "/docs/reference/prune",
          children: "Turborepo의 정리 기능"
        }), "을 사용하여 Docker 이미지에서 사용되지 않는 종속성을 제거하여 더 가벼운 이미지를 만들 수 있습니다. 종속성이 의도된 패키지에 설치되면 Turborepo는 lockfile을 읽고 필요한 패키지에서 사용되지 않는 종속성을 제거할 수 있습니다."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "루트에-종속성-적게",
      children: "루트에 종속성 적게"
    }), "\n", _jsxs(_components.p, {
      children: ["위의 첫 번째 원칙에 따라 ", _jsx(_components.a, {
        href: "#install-dependencies-where-theyre-used",
        children: "사용되는 곳에 종속성 설치"
      }), "하면 자연스럽게 Workspace 루트에 종속성이 거의 없게 됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["Workspace 루트에 속하는 유일한 종속성은 ", _jsx(_components.strong, {
        children: "저장소 관리를 위한 도구"
      }), "이며, 애플리케이션과 라이브러리를 빌드하기 위한 종속성은 해당 패키지에 설치됩니다. 루트에 설치하는 것이 합리적인 종속성의 몇 가지 예는 ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/turbo",
        children: _jsx(_components.code, {
          children: "turbo"
        })
      }), ", ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/husky",
        children: _jsx(_components.code, {
          children: "husky"
        })
      }), " 또는 ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/lint-staged",
        children: _jsx(_components.code, {
          children: "lint-staged"
        })
      }), "입니다."]
    }), "\n", _jsx(_components.h2, {
      id: "종속성-관리",
      children: "종속성 관리"
    }), "\n", _jsx(_components.h3, {
      id: "turborepo는-종속성을-관리하지-않음",
      children: "Turborepo는 종속성을 관리하지 않음"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 종속성 관리에서 역할을 하지 않으며, 해당 작업을 선택한 패키지 관리자에 맡깁니다."
    }), "\n", _jsx(_components.p, {
      children: "올바른 외부 종속성 버전 다운로드, 심볼릭 링크 생성 및 모듈 해결과 같은 작업을 처리하는 것은 패키지 관리자의 몫입니다. 이 페이지의 권장 사항은 Workspace에서 종속성을 관리하기 위한 모범 사례이며 Turborepo에서 강제하지 않습니다."
    }), "\n", _jsx(_components.h3, {
      id: "패키지-관리자-간-모듈-해결-차이",
      children: "패키지 관리자 간 모듈 해결 차이"
    }), "\n", _jsx(_components.p, {
      children: "패키지 관리자에는 서로 다른 모듈 해결 알고리즘이 있어 예측하기 어려운 동작 차이가 발생합니다."
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 문서에서는 패키지 관리자의 예상 동작에 따라 많은 권장 사항을 제공합니다. 종속성 처리 방법에 대한 범위는 최선의 노력이며 패키지 관리자 또는 저장소의 요구 사항에 맞게 문서화된 동작을 조정해야 할 수 있습니다."
    }), "\n", _jsx(_components.p, {
      children: "그러나 모든 패키지 관리자 또는 특정 패키지 관리자에 대해 보편적으로 잘못된 것으로 보이는 문서 문제를 발견하면 GitHub Issue를 통해 알려주시면 개선할 수 있습니다."
    }), "\n", _jsx(_components.h3, {
      id: "node_modules-위치",
      children: "node_modules 위치"
    }), "\n", _jsxs(_components.p, {
      children: ["패키지 관리자 선택, 버전, 설정 및 Workspace에서 종속성이 설치된 위치에 따라 Workspace 내의 다양한 위치에서 ", _jsx(_components.code, {
        children: "node_modules"
      }), "와 그 안의 종속성을 볼 수 있습니다. 종속성은 루트 ", _jsx(_components.code, {
        children: "node_modules"
      }), ", 패키지의 ", _jsx(_components.code, {
        children: "node_modules"
      }), " 또는 둘 다에서 찾을 수 있습니다."]
    }), "\n", _jsx(_components.p, {
      children: "스크립트와 작업이 필요한 종속성을 찾을 수 있는 한 패키지 관리자가 올바르게 작동하고 있는 것입니다."
    }), "\n", _jsxs(Callout, {
      type: "info",
      title: "코드에서 `node_modules` 참조",
      children: [_jsxs(_components.p, {
        children: ["Workspace 내 ", _jsx(_components.code, {
          children: "node_modules"
        }), "의 특정 위치는 패키지 관리자의 공개 API의 일부가 아닙니다. 즉, ", _jsx(_components.code, {
          children: "node_modules"
        }), "를 직접 참조하는 것(예: ", _jsx(_components.code, {
          children: "node ./node_modules/a-package/dist/index.js"
        }), ")은 Workspace 주변의 다른 종속성 변경으로 인해 디스크의 종속성 위치가 변경될 수 있으므로 취약할 수 있습니다."]
      }), _jsx(_components.p, {
        children: "대신 가능한 한 Node.js 생태계의 규칙을 사용하여 종속성 모듈에 액세스하세요."
      })]
    }), "\n", _jsx(_components.h3, {
      id: "동일한-버전의-종속성-유지",
      children: "동일한 버전의 종속성 유지"
    }), "\n", _jsx(_components.p, {
      children: "일부 모노레포 유지 관리자는 규칙에 따라 모든 패키지에서 종속성을 동일한 버전으로 유지하는 것을 선호합니다. 이를 달성하는 방법에는 여러 가지가 있습니다:"
    }), "\n", _jsx(_components.h4, {
      id: "전용-도구-사용",
      children: "전용 도구 사용"
    }), "\n", _jsxs(_components.p, {
      children: ["이 특정 목적을 위해 ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/syncpack",
        children: _jsx(_components.code, {
          children: "syncpack"
        })
      }), ", ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/@manypkg/cli",
        children: _jsx(_components.code, {
          children: "manypkg"
        })
      }), " 및 ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/sherif",
        children: _jsx(_components.code, {
          children: "sherif"
        })
      }), "와 같은 도구를 사용할 수 있습니다."]
    }), "\n", _jsx(_components.h4, {
      id: "패키지-관리자-사용",
      children: "패키지 관리자 사용"
    }), "\n", _jsx(_components.p, {
      children: "패키지 관리자를 사용하여 하나의 명령으로 종속성 버전을 업데이트할 수 있습니다."
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsxs(Tab, {
        value: "pnpm",
        children: [_jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " up"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --recursive"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " typescript@latest"
                })]
              })
            })
          })
        }), _jsx("small", {
          children: _jsx(_components.a, {
            href: "https://pnpm.io/cli/update#--recursive--r",
            children: "→ pnpm 문서"
          })
        })]
      }), _jsxs(Tab, {
        value: "yarn",
        children: [_jsx(_components.p, {
          children: "Yarn 1:"
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " upgrade-interactive"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --latest"
                })]
              })
            })
          })
        }), _jsx("small", {
          children: _jsx(_components.a, {
            href: "https://classic.yarnpkg.com/en/docs/cli/upgrade-interactive",
            children: "→ Yarn 1 문서"
          })
        }), _jsx(_components.p, {
          children: "Yarn 2+:"
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " upgrade"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " typescript@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --upgrade"
                })]
              })
            })
          })
        }), _jsx("small", {
          children: _jsx(_components.a, {
            href: "https://yarnpkg.com/cli/up",
            children: "→ Yarn 2+ 문서"
          })
        })]
      }), _jsxs(Tab, {
        value: "npm",
        children: [_jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " install"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " typescript@latest"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " --workspaces"
                })]
              })
            })
          })
        }), _jsx("small", {
          children: _jsx(_components.a, {
            href: "https://docs.npmjs.com/cli/v7/using-npm/config#workspaces",
            children: "→ npm 문서"
          })
        })]
      }), _jsxs(Tab, {
        value: "bun (Beta)",
        children: [_jsx(_components.p, {
          children: "동등한 명령 없음"
        }), _jsx("small", {
          children: _jsx(_components.a, {
            href: "https://bun.sh/docs/install/workspaces",
            children: "→ Bun 문서"
          })
        })]
      })]
    }), "\n", _jsx(_components.h4, {
      id: "pnpm-카탈로그",
      children: "pnpm 카탈로그"
    }), "\n", _jsx(_components.p, {
      children: "pnpm v9.5+에서는 카탈로그를 사용하여 종속성 버전 범위를 재사용 가능한 상수로 정의할 수 있습니다. Workspace 전체에서 동일한 값을 참조하므로 종속성을 동일한 버전으로 유지합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsx(_components.a, {
        href: "https://pnpm.io/catalogs",
        children: "pnpm 카탈로그 문서"
      }), "를 방문하세요."]
    }), "\n", _jsx(_components.h4, {
      id: "ide-사용",
      children: "IDE 사용"
    }), "\n", _jsxs(_components.p, {
      children: ["IDE의 리팩토링 도구를 사용하여 저장소의 모든 ", _jsx(_components.code, {
        children: "package.json"
      }), " 파일에서 종속성 버전을 한 번에 찾고 바꿀 수 있습니다. ", _jsx(_components.code, {
        children: "package.json"
      }), " 파일에서 ", _jsx(_components.code, {
        children: "next"
      }), " 패키지의 모든 인스턴스를 찾고 원하는 버전으로 바꾸려면 ", _jsx(_components.code, {
        children: "\"next\": \".*\""
      }), "와 같은 정규식을 사용해 보세요. 완료되면 패키지 관리자의 install 명령을 실행하여 lockfile을 업데이트해야 합니다."]
    }), "\n", _jsx(_components.h2, {
      id: "다음-단계",
      children: "다음 단계"
    }), "\n", _jsxs(_components.p, {
      children: ["이제 Workspace에서 효과적으로 종속성을 관리하는 방법을 알았으므로 모노레포에서 종속성으로 사용할 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/creating-an-internal-package",
        children: "Internal Package를 생성"
      }), "해 보겠습니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
